import flagsmith from 'flagsmith';
import { useFlags } from 'flagsmith/react';
import { IFlagsmithFeature } from 'flagsmith/types';

enum FlagsmithFlags {
    MODULAR = 'feature_modular',
    REEDIT = 'feature_reedit',
    MODULAR_FRESHCHAT = 'feature_modular_freshchat',
    USER_ATTRIBUTES = 'feature_user_attributes',
    FAMILY_ADD_ONS = 'feature_family_add_ons',
    PARTNER_SUPPORT = 'feature_partner_support',
    PAYMENT_INSTALLMENTS = 'feature_payment_installments',
    HOMEPAGE_DISCLAIMER = 'homepage_disclaimer',
    CUSTOM_OTP = 'feature_custom_otp',
    PURCHASE_ATTRIBUTES = 'feature_purchase_attributes',
    MODULAR_REDIRECT = 'feature_modular_redirect'
}

// define flags to run locally
const LOCAL_FLAGS: Record<FlagsmithFlags, IFlagsmithFeature> = {
    [FlagsmithFlags.MODULAR]: { enabled: true, value: '' },
    [FlagsmithFlags.REEDIT]: { enabled: true, value: '' },
    [FlagsmithFlags.MODULAR_FRESHCHAT]: { enabled: false, value: '' },
    [FlagsmithFlags.USER_ATTRIBUTES]: { enabled: false, value: '' },
    [FlagsmithFlags.FAMILY_ADD_ONS]: { enabled: false, value: '' },
    [FlagsmithFlags.PARTNER_SUPPORT]: { enabled: false, value: '' },
    [FlagsmithFlags.PAYMENT_INSTALLMENTS]: { enabled: true, value: 'Will be deducted from your next salary' },
    [FlagsmithFlags.PURCHASE_ATTRIBUTES]: { enabled: true, value: '' },
    [FlagsmithFlags.HOMEPAGE_DISCLAIMER]: {
        enabled: true,
        value: `In the event that the minimum threshold requirement for modular policy upgrades is not achieved
        all employees will remain covered under the base policy. No salary deductions will apply.`
    },
    [FlagsmithFlags.CUSTOM_OTP]: { enabled: true, value: '' },
    [FlagsmithFlags.MODULAR_REDIRECT]: { enabled: true, value: '' }
};

// to use in components
const useFeatureFlag = (flag: FlagsmithFlags): boolean => {
    const flags = useFlags([flag]);
    return flags[flag].enabled;
};

// for multiple features
const useFeatureFlags = (flags: FlagsmithFlags[]): Record<FlagsmithFlags, IFlagsmithFeature> => {
    return useFlags(flags);
};

// get value of a feature flag
const useFeatureFlagValue = (flag: FlagsmithFlags): unknown => {
    const flags = useFlags([flag]);
    return flags[flag].value;
};

// to use outside components
const isFlagsmithFeatureEnabled = (flag: FlagsmithFlags): boolean => {
    return flagsmith.hasFeature(flag);
};

export { FlagsmithFlags, LOCAL_FLAGS, useFeatureFlag, useFeatureFlags, useFeatureFlagValue, isFlagsmithFeatureEnabled };
